import React, {useState, useEffect} from "react";
import "../../common/main.scss";
import "./blind.scss";
import {Event, EventList} from "./event";

const year = 2024;
const monthIdx = 1;
const day = 6;

const blindEvents = new EventList([
    new Event(
        <p>Bring a thick jacket and meet at the <a href="https://maps.app.goo.gl/WD43VtNKx9N9gXX28">Polish Triangle</a>, find each other and introduce yourselves</p>,
        new Date(year, monthIdx, day, 20, 30),
        null,
        new Date(year, monthIdx, day, 0, 0)
    ),
    new Event(
        <p>Begin walking to <a href="https://maps.app.goo.gl/iUD8hZHgnkt3642Q7">Bonchon</a></p>,
        new Date(year, monthIdx, day, 20, 40),
    ),
    new Event(
        <p>Admire the fried chicken at Bonchon and eat down the road at <a href="https://maps.app.goo.gl/mUyBazHSRS32Ldyt9">Lilac Tiger</a> instead</p>,
        new Date(year, monthIdx, day, 20, 45),
    ),
    new Event(
        <p>You have a reservation at 9:55 but try to be 15 minutes early! IF YOU ARE LATE YOU CANNOT PLAY. Pay for food and begin walking to <a href="https://maps.app.goo.gl/YX5WdT86x7ptBpU47">Big Mini Putt Club</a></p>,
        new Date(year, monthIdx, day, 21, 30),
    ),
    new Event(
        <p>Arrive at <a href="https://maps.app.goo.gl/YX5WdT86x7ptBpU47">Big Mini Putt Club</a>, check-in under Sean's name and pay for the rest of the deposit using his card on file. Now you both owe me $5 on Venmo (@knightsean00)</p>,
        new Date(year, monthIdx, day, 21, 50),
    ),
    new Event(
        <p>Pay and leave mini-golf. Go to <a href="https://maps.app.goo.gl/VgyZv3PWu2RsMizt9">this bridge</a></p>,
        new Date(year, monthIdx, day, 23, 0),
    ),
    new Event(
        <p>Arrive at <a href="https://maps.app.goo.gl/VgyZv3PWu2RsMizt9">this bridge</a> on the side closest to the city. Discuss/admire the view and Sean's ability to plan blind dates</p>,
        new Date(year, monthIdx, day, 23, 30),
    ),
    new Event(
        <p>Pay the remaining $5.90 that you each owe to Sean on Venmo (@knightsean00) and do whatever I guess</p>,
        new Date(year, monthIdx, day, 23, 35),
        new Date(year, monthIdx, day + 1, 0, 0)
    ),
]);


function Blind(props) {
    const [time, setTime] = useState(new Date());

    useEffect(() => {
        const interval = setInterval(() => {
            setTime(new Date());
        }, 1000);
    });

    // const pastStart = new Date();
    // pastStart.setMinutes(pastStart.getMinutes() - 1);

    // const pastEnd = new Date();
    // pastEnd.setMinutes(pastEnd.getMinutes() - 1);

    // const futureStart = new Date();
    // futureStart.setMinutes(futureStart.getMinutes() + 1);

    // const farFutureStart = new Date();
    // farFutureStart.setMinutes(farFutureStart.getMinutes() + 2);

    // const farFutureEnd = new Date();
    // farFutureEnd.setMinutes(farFutureEnd.getMinutes() + 3);

    // const blindEvents = new EventList([
    //     new Event(
    //         <p>The Past</p>,
    //         pastStart,
    //         pastEnd,
    //         new Date(year, monthIdx, day, 0, 0)
    //     ),
    //     new Event(
    //         <p>The Present</p>,
    //         new Date(),
    //     ),
    //     new Event(
    //         <p>The Future</p>,
    //         futureStart,
    //     ),
    //     new Event(
    //         <p>The Future</p>,
    //         farFutureStart,
    //         farFutureEnd
    //     )
    // ]);

    return (
        <div className="section bg-black">
            <div className="container pt-2 pb-2 pr-1 pl-1">
                <h1>Blind</h1>
                {blindEvents.events.map((i, idx) => <div className="row" key={idx}> {i.render(props.renderAll)} </div>)}
            </div>
        </div>
    )
}

Blind.defaultProps = {
    renderAll: false,
}

export default Blind;
